/** Soft warnings from working-time / rest-rule evaluation (shift already saved). */

export function extractRestRuleWarnings(payload: unknown): string[] | undefined {
  if (!payload || typeof payload !== 'object') return undefined;
  const w = (payload as { restRuleWarnings?: unknown }).restRuleWarnings;
  const list = Array.isArray(w) ? (w.filter((x) => typeof x === 'string') as string[]) : undefined;
  return list?.length ? list : undefined;
}
